module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Light-Italic.64c8db9.woff";